import BuyBox from "@/components/buybox/BuyBoxView"

export default function BuyBoxScreen() {
  return <BuyBox />
}
